import { render, staticRenderFns } from "./DocumentDetailHeader.vue?vue&type=template&id=2ff2dc18&scoped=true"
import script from "./DocumentDetailHeader.vue?vue&type=script&lang=js"
export * from "./DocumentDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./DocumentDetailHeader.vue?vue&type=style&index=0&id=2ff2dc18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2dc18",
  null
  
)

export default component.exports